// extracted by mini-css-extract-plugin
export default {"nameInput":"RoomType_nameInput__YCRlW","statusText":"RoomType_statusText__rckrx","editAction":"RoomType_editAction__GACjE"};